import React, { useEffect, useState } from "react"

const Calendar = ({
  className = "calendar",
  calendarId,
  dateFormat,
  groupEventsBy,
  daysForward = null,
  calendarLink = false,
}) => {
  const [timeMin, setTimeMin] = useState(null)

  useEffect(() => {
    setTimeMin(new Date().toISOString())

    const getElementByDataHandle = handle =>
      document.querySelector('[data-handle="' + handle + '"]')

    // Initialize
    const scriptId = "oma-google-calendar"
    const script = document.createElement("script")
    const existingScript = document.getElementById(scriptId)

    if (existingScript) return

    script.id = scriptId
    script.src = "/oma-google-calendar.cjs.js"
    script.async = true
    script.type = "module"
    document.body.appendChild(script)
  }, [])

  const timeMax = daysForward => {
    const now = new Date()

    return new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + daysForward
    ).toISOString()
  }

  const properties = {
    class: "calendar",
    "data-handle": "oma-calendar",
    "api-key": "AIzaSyAODZF9B7KfBWSqDeW6kaP0ALUnM7VPkB8",
    "calendar-id": calendarId,
    "time-min": timeMin,
    ...(daysForward && { "time-max": timeMax(daysForward) }),
    ...(groupEventsBy && { "group-events-by": groupEventsBy }),
    ...(dateFormat && { "date-format": dateFormat }),
  }

  return (
    <div className={className}>
      {timeMin && <oma-google-calendar {...properties}></oma-google-calendar>}
      <p>
        <a
          href={`https://calendar.google.com/calendar/embed?src=${calendarId}&ctz=Europe%2FStockholm`}
          className="link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Se hela kalendern
        </a>
      </p>
    </div>
  )
}

export default Calendar
